module.exports = __webpack_public_path__ + "img/t5-11.806b7d10.svg";